import React from 'react'

export const CharterOfferHeader = () => {
  return (
    <div className="OfferHeader">
      <div className="container">
        <div className="row">
            <div className="col-12">
                <h1>Our Charter Offer</h1>
                <p>It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently</p>
            </div>
        </div>
      </div>
    </div>
  )
}